// extracted by mini-css-extract-plugin
export default {"spin":"OKZCNyPYQlBVkbG1hZfr"};